var _rect, _rect2, _rect3, _rect4, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinesscentral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 40,
    viewBox: "0 0 170 40",
    role: "img",
    "aria-label": "Microsoft",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 15,
    height: 15,
    fill: "#F25022"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 4,
    width: 15,
    height: 15,
    fill: "#7FBA00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 21,
    width: 15,
    height: 15,
    fill: "#00A4EF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21,
    width: 15,
    height: 15,
    fill: "#FFB900"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 27,
    fontFamily: "Segoe UI, Helvetica Neue, Helvetica, Arial, sans-serif",
    fontSize: 21,
    fontWeight: 600,
    fill: "#737373",
    letterSpacing: -0.2
  }, "Microsoft")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinesscentral);
export default __webpack_public_path__ + "static/media/businesscentral.9bd58bd78b1d43cc93620550528d494d.svg";
export { ForwardRef as ReactComponent };